import misCertificados from "../../articles/misCertificados.js"
import actualizarLinuxCambiandoLosRepositorios from '../../articles/actualizarLinuxCambiandoLosRepositorios.js'
import obtenerSetearScrollEnJsProgramacion from '../../articles/obtenerSetearScrollEnJsProgramacion.js'
import initramfsUnexpectedInconsistencyLinux from '../../articles/initramfs-unexpected-inconsistency-linux.js'
import personalizacionParaSublimeText3 from '../../articles/personalizacionParaSublimeText3.js'
import notasLibreriasDeReactjs from '../../articles/notasLibreriasDeReactjs.js'
import problemasFrecuentesConGit from '../../articles/problemasFrecuentesConGit.js'
import deshabilitarActualizacionesAutomaticasWindows10 from '../../articles/deshabilitarActualizacionesAutomaticasWindows10.js'
import instalarSdkDeAndroidStudioLinux from '../../articles/instalarSdkDeAndroidStudioLinux.js'
import pantallaNegraEnObsStudioWindows10 from '../../articles/pantallaNegraEnObsStudioWindows10.js'
import instalarMongoDbEnKubuntuJammyProblemasLinux from '../../articles/instalarMongoDbEnKubuntuJammyProblemasLinux.js'
import solucionLoadlibraryFailed1114Windows10 from '../../articles/solucionLoadlibraryFailed1114Windows10.js'
import instalarIdiomasWindows7 from '../../articles/instalarIdiomasWindows7';
import configuracionBasicaGitFork from '../../articles/configuracionBasicaGitFork';
import configuracionDeRepositoriosLinux from '../../articles/configuracionDeRepositoriosLinux.js'
import solucionActualizacionesConError80072efeWindows7 from '../../articles/solucionActualizacionesConError80072efeWindows7.js'
import listaDeRepositoriosLinux from '../../articles/listaDeRepositoriosLinux.js'
import problemasConRepositoriosYClavePublicaLinux from '../../articles/problemasConRepositoriosYClavePublicaLinux.js'
import solucionNoBooteableDeviceGrubRescue from "../../articles/solucionNoBooteableDeviceGrubRescue.js"

const articlesAll = {
	misCertificados,
	actualizarLinuxCambiandoLosRepositorios,
	obtenerSetearScrollEnJsProgramacion,
	instalarSdkDeAndroidStudioLinux,
	initramfsUnexpectedInconsistencyLinux,
	personalizacionParaSublimeText3,
	notasLibreriasDeReactjs,
	problemasFrecuentesConGit,
	deshabilitarActualizacionesAutomaticasWindows10,
	pantallaNegraEnObsStudioWindows10,
	instalarMongoDbEnKubuntuJammyProblemasLinux,
	solucionLoadlibraryFailed1114Windows10,
	instalarIdiomasWindows7,
	configuracionBasicaGitFork,
	configuracionDeRepositoriosLinux,
	solucionActualizacionesConError80072efeWindows7,
	listaDeRepositoriosLinux,
	problemasConRepositoriosYClavePublicaLinux,
	solucionNoBooteableDeviceGrubRescue
}

export default articlesAll